import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://zofiumbackend-purnanshuborkarofficial.b4a.run",
});

const initialState = {
  value: {},
  loading: true,
};

const coursesReducer = createSlice({
  name: "search",
  initialState,
  reducers: {
    setCourses: (state, action) => {
      state.value = action.payload;
      state.loading = false;
    },
    setLoadingTrue: (state) => {
      state.loading = true;
    },
  },
});

const { setCourses, setLoadingTrue } = coursesReducer.actions;

export default coursesReducer.reducer;

export const getCoursesAsync = (searchQuery = "/courses") => {
  return async (dispatch) => {
    try {
      dispatch(setLoadingTrue());
      const res = await axiosInstance.get("/api" + searchQuery);
      dispatch(setCourses(res.data));
    } catch (error) {
      console.log(error);
    }
  };
};

export const getCourseAsync = (searchQuery = "/courses/course?courseID=") => {
  return async (dispatch) => {
    try {
      dispatch(setLoadingTrue());
      const res = await axiosInstance.get("/api" + searchQuery);
      dispatch(
        setCourses({
          success: true,
          data: [res.data.data],
        })
      );
    } catch (error) {
      console.log(error);
    }
  };
};
